import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/img/icons/close-circle-2.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "filterModal",
  tabindex: "-1",
  "aria-labelledby": "filterModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group mb-15" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "form-group mb-15" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "form-group mb-15" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group mb-15" }
const _hoisted_16 = { class: "col-lg-6 mb-md-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h5", {
            class: "modal-title text-title",
            id: "filterModalLabel"
          }, "Filter"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close p-0",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Image"
            })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.applyFilter && _ctx.applyFilter(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-10" }, "Customer", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.customer_id) = $event)),
                    class: "bg_ash border-0 rounded-1 fs-14 text-optional w-100 p-2"
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("option", { value: "" }, "All Customers", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customers, (customer) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: customer.id,
                        value: customer.id
                      }, _toDisplayString(customer.name), 9, _hoisted_8))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.customer_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-10" }, "Warehouse", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.warehouse_id) = $event)),
                    class: "bg_ash border-0 rounded-1 fs-14 text-optional w-100 p-2"
                  }, [
                    _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, "All Warehouses", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouses, (warehouse) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: warehouse.id,
                        value: warehouse.id
                      }, _toDisplayString(warehouse.name), 9, _hoisted_11))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.filters.warehouse_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-10" }, "Reference No", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.reference_no) = $event)),
                    type: "text",
                    class: "w-100 d-block shadow-none fs-14 bg_ash rounded-1 text-black border-0 placeholder-1 p-2",
                    placeholder: "Enter Reference No"
                  }, null, 512), [
                    [_vModelText, _ctx.filters.reference_no]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block fs-14 text-black mb-10" }, "Status", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.status) = $event)),
                    class: "bg_ash border-0 rounded-1 fs-14 text-optional w-100 p-2"
                  }, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "Completed" }, "Completed", -1),
                    _createElementVNode("option", { value: "Pending" }, "Pending", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.filters.status]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn style-four w-100 d-block",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
                }, " Reset ")
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-lg-6" }, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn style-five w-100 d-block",
                  "data-bs-dismiss": "modal"
                }, " Apply Filter ")
              ], -1))
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}